import { EmailTemplate } from "screens/mass-mail/types";

export const MISSING_DOCUMENTS_REMINDER_TEMPLATES: EmailTemplate[] = [
  {
    id: "rental_missing_documents_reminder",
    templateType: "Verhuur",
    label: "Ontbrekende documenten herinnering",
    subject: "Ontbrekende documenten - herinnering",
    content: `<p>Beste {contact.firstName},</p>

<p>Bij nazicht van uw huurdossier merken wij op dat wij nog niet alle nodige documenten hebben ontvangen.</p>

<p>Het gaat om de volgende ontbrekende documenten:</p>

<p><strong>{OntbrekendeDocumenten}</strong></p>

<p>Gelieve deze documenten zo snel mogelijk aan ons te bezorgen door op deze e-mail te antwoorden.</p>

<p>Heeft u de gevraagde documenten intussen al doorgestuurd, dan mag u deze herinnering als onbestaande beschouwen.</p>

<p>Alvast bedankt voor uw medewerking.</p>

<p>Met vriendelijke groeten,<br/>
<strong>Team Verhuur - Yally</strong><br/>
<a href="mailto:rent@yally.be">rent@yally.be</a></p>`,
  },
];
